<!--
 * @Author: wzh
 * @Date: 2023-05-30 16:56:50
 * @LastEditTime: 2023-07-04 09:58:35
 * @Description: 第三方登录 
-->
<template>
  <div class="social_login">
    <a-result v-if="msg" status="warning" :title="msg">
      <template #extra>
        <a-button type="primary" @click="handleBack">返回登录页</a-button>
      </template>
    </a-result>

    <a-result v-if="success" status="success" title="绑定成功！">
      <template #extra>
        <a-button type="primary" @click="handleSuccess">返回</a-button>
      </template>
    </a-result>
  </div>
</template>
<script>
import { commonAPI } from "@/apis";
import { commonMethods } from "@/views/authPages/mixins/common";

export default {
  name: "thirdLogin",
  mixins: [commonMethods],
  data() {
    return {
      msg: "",
      success: false,
    };
  },
  created() {
    let path = this.$route.path;
    let query = this.$route.query;
    if (path.includes("thirdLogin")) {
      this.loginBack(path, query);
    } else {
      this.loginBind(path, query);
    }
  },
  methods: {
    // 登录
    async loginBack(path, query) {
      let url = `/logon/oauth20/callback/${path.replace("/thirdLogin/", "")}`;

      const { code, data, message } = await commonAPI.getAction(url, query);
      if (code == 0) {
        this.msg = "";
        let obj = {
          user: {
            username: data.username,
            displayName: data.displayName,
            email: data.email,
            mobile: data.mobile,
          },
          token: data.token,
        };

        this.$store.commit("auth/setUser", obj.user);
        this.$store.commit("auth/setToken", obj.token);

        if (data.remeberMe) {
          this.$cookies.set("REMEMBER_ME", obj, "7d");
        }

        let before_login = {
          noSingleLogin: data.noSingleLogin,
          editPwd: data.editPwd,
          showInfo: data.showInfo,
          userInfoConfim: data.userInfoConfim,
          secAuth: data.secAuth,
        };
        sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(before_login));
        this.jumpComputed();
      } else {
        this.msg = message;
      }
    },

    // 绑定
    async loginBind(path, query) {
      let url = `/logon/oauth20/bind/${path.replace("/thirdBind/", "")}`;
      const { code, message } = await commonAPI.getAction(url, query);
      if (code == 0) {
        this.success = true;
        this.msg = "";
      } else {
        this.success = false;
        this.msg = message;
      }
    },

    // 返回登录
    handleBack() {
      const url = this.$router.resolve({ path: "/" });
      window.location.href = url.href;
    },

    // 绑定成功返回
    handleSuccess() {
      const url = this.$router.resolve({ path: "/authserver/account/social" });
      window.location.href = url.href;
    },
  },
};
</script>
<style lang="scss" scoped>
.social_login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
